import {
    COMPLEX_TOPICS_DISCIPLINES_FETCH_COMPLETED,
    COMPLEX_TOPICS_DISCIPLINES_FETCH_STARTED,
    COMPLEX_TOPICS_DISCIPLINES_FETCH_FAILED,
    COMPLEX_TOPICS_DISCIPLINES_GET_CURRICULUM,
    COMPLEX_TOPICS_DISCIPLINES_GET_DISCIPLINES,
    COMPLEX_TOPICS_DISCIPLINES_CLEAR,
    COMPLEX_TOPICS_DISCIPLINES_VIEW_FETCH_STARTED,
    COMPLEX_TOPICS_DISCIPLINES_VIEW_FETCH_COMPLETED,
    COMPLEX_TOPICS_DISCIPLINES_VIEW_FETCH_ERROR,
    COMPLEX_TOPICS_DISCIPLINES_VIEW_CLEAR,
  } from "./types";
  import { BACKEND_URL_PREFIX, itemsPerPage } from "../utils/const";
  import { buildDefaultHeaders } from "./helper";
  import { checkAndUpdateToken } from "./auth";

  // Перечень КТП дисциплин: GET /complex_thematic_planning/{xp_key}/{idfaculty}/{idcurriculum}/{cid}
  // xp_key обязателен по значению — 0 бэк отвергает с 400 «Не указан учебный год (xp_key)».
  // Остальные три — 0 значит «отбор выключен».
  export const getComplexTopicsDisciplines = (params) => async (
    dispatch,
    getState
  ) => {
    await dispatch(checkAndUpdateToken());
    const {xp_key, idfaculty, idcurriculum, cid, page = 0 } = params
    if (getState().auth.token) {
      dispatch({ type: COMPLEX_TOPICS_DISCIPLINES_FETCH_STARTED });

      const limit = itemsPerPage
      const offset = page * limit

      const query = new URLSearchParams({ limit, offset })

      try {
        const response = await fetch(
          `${BACKEND_URL_PREFIX}/complex_thematic_planning/${xp_key}/${idfaculty}/${idcurriculum}/${cid}?${query}`,
          buildDefaultHeaders(getState)
        );

        if (response.ok) {
          const result = await response.json()
          dispatch({ type: COMPLEX_TOPICS_DISCIPLINES_FETCH_COMPLETED, complex: result });
        } else {
          // отказ сервера не должен выглядеть как «данных нет» — код уходит в стор
          dispatch({ type: COMPLEX_TOPICS_DISCIPLINES_FETCH_FAILED, errorStatus: response.status });
        }
      } catch {
        dispatch({ type: COMPLEX_TOPICS_DISCIPLINES_FETCH_FAILED, errorStatus: 0 });
      }
    }
  }

  export const clearComplexTopicsDisciplines = () => ({ type: COMPLEX_TOPICS_DISCIPLINES_CLEAR });

export const getComplexTopicsDisciplineView = (id_ctp) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return;

  dispatch({ type: COMPLEX_TOPICS_DISCIPLINES_VIEW_FETCH_STARTED });

  try {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/complex_thematic_planning/${id_ctp}`,
      buildDefaultHeaders(getState)
    );

    if (response.ok) {
      const result = await response.json();
      dispatch({ type: COMPLEX_TOPICS_DISCIPLINES_VIEW_FETCH_COMPLETED, data: result });
    } else {
      dispatch({ type: COMPLEX_TOPICS_DISCIPLINES_VIEW_FETCH_ERROR, errorStatus: response.status });
    }
  } catch {
    dispatch({ type: COMPLEX_TOPICS_DISCIPLINES_VIEW_FETCH_ERROR, errorStatus: 0 });
  }
};

export const clearComplexTopicsDisciplineView = () => ({ type: COMPLEX_TOPICS_DISCIPLINES_VIEW_CLEAR });

  // Перечень дисциплин поля отбора: GET /course/complex_thematic_planning/{curriculumid}.
  // Вызывается только с выбранным учебным планом: при 0 бэк отдаёт общий перечень всех планов
  // в другом формате (массив верхнего уровня с `predmet`), и он режиму не нужен.
  // Учебный план без дисциплин — 404 {"success": false}, перечень при этом должен опустеть,
  // иначе в поле остаются дисциплины прошлого плана.
  export const getDisciplinesForComplexTopicsDisciplines = (params) => async (
    dispatch,
    getState
  ) => {
    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {
      const response = await fetch(
        `${BACKEND_URL_PREFIX}/course/complex_thematic_planning/${params}`,
        buildDefaultHeaders(getState)
      );

      if (response.ok) {
        const result =( await response.json()).course;
        dispatch({ type: COMPLEX_TOPICS_DISCIPLINES_GET_DISCIPLINES, disciplines: params == 0 ? [] : (result || []) });
      } else {
        dispatch({ type: COMPLEX_TOPICS_DISCIPLINES_GET_DISCIPLINES, disciplines: [] });
      }
    }
}

  // Учебный план не выбран — поле «Дисциплина» очищается без запроса
  export const clearDisciplinesForComplexTopicsDisciplines = () => ({
    type: COMPLEX_TOPICS_DISCIPLINES_GET_DISCIPLINES,
    disciplines: [],
  });

  // Перечень учебных планов поля отбора: GET /curriculum/complex_thematic_planning/{idfaculty},
  // 0 — факультет не выбран (планы всех факультетов)
export const getCurriculumForComplexTopicsDisciplines = (idfaculty) => async (
    dispatch,
    getState
  ) => {
    await dispatch(checkAndUpdateToken());

    if (getState().auth.token) {
      const response = await fetch(
        `${BACKEND_URL_PREFIX}/curriculum/complex_thematic_planning/${idfaculty}`,
        buildDefaultHeaders(getState)
      );

      if (response.ok) {
        const result =( await response.json());
        dispatch({ type: COMPLEX_TOPICS_DISCIPLINES_GET_CURRICULUM, curriculum: result });
      } else {
        dispatch({ type: COMPLEX_TOPICS_DISCIPLINES_GET_CURRICULUM, curriculum: [] });
      }
    }
}
